module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedicationPage",
    attrs: {
      "id": "ded01"
    }
  }, [_c('p', {
    staticClass: "c1"
  }, [_c('span', [_c('br'), _vm._v("This book is for"), _c('br'), _vm._v("\nVirginia Kidd,"), _c('br'), _vm._v("\none of the sweetest people ever to grace"), _c('br'), _vm._v("\nthe science fiction field.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }), _vm._v(" "), _c('p', {
    staticClass: "c1"
  }, [_c('span', [_vm._v("And for Kim,"), _c('br'), _vm._v("\nmy wonderful wife,"), _c('br'), _vm._v("\nwho makes everything possible.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f106036","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/9780743420488_ded01.vue
// module id = 66
// module chunks = 0